import styled from "styled-components";

export const ProtocolHeaderMainDiv = styled.div`
  margin: 20px auto 0;
  width: 100%;
  max-width: 860px;
  display: flex;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const ProtocolHeaderDiv = styled.div`
  width: 100%;
  display: flex;
`;
export const ProtocolTitle = styled.p`
  padding: ${({ padding }) => padding && padding};
  width: ${({ width }) => width && width};
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  text-align: ${({ center }) => center && "center"};
`;
export const DaysDiv = styled.div`
  padding-left: 43px;
  width: 270px;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;
export const DaysText = styled.p`
  width: 23px;
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  text-align: center;
`;
